import { ILightRailItem } from '../../../types'
import {
  ProgramNameTitle,
  RailItemImage,
  RailItemImageWrap,
  RailItemWrap,
} from './RailItemProgram.style'
import { useMemo, useState } from 'react'
import { RailItemProgramPlaceHolder } from '../ComponentsFactory/ComponentsFactory.style'
import { ottRoot } from '../../Api'
import Link from '../../../components/Link/Link'

export const RailItemProgram = ({
  data,
  showTitle = false,
  compName,
}: {
  data?: ILightRailItem
  isLast: boolean
  isFirst: boolean
  showTitle?: boolean
  compName?: string
}) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const image = useMemo(() => {
    let img
    if (data) {
      if (data?.images) {
        img = data.images.find(
          img => img.imageTypeName === 'Portrait_9_16'
        )?.url
      }

      if (img) {
        return {
          found: true,
          url: img + `/width/400/height/${400 * 1.77}/quality/70`,
        }
      }
    }

    return {
      found: false,
      url: 'https://media3.reshet.tv/image/upload/c_scale,q_auto:best,w_320/v1709542182/ott/400x400_Logo_Clear_1.webp',
    }
  }, [data])
  const href = useMemo(() => {
    if (data) {
      const { SeriesID } = data.metas || {}

      return `${ottRoot}/series/${String(SeriesID)}`
    }
    return '#'
  }, [data])

  if (!data) {
    return null
  }
  if (!data.id) {
    return <RailItemProgramPlaceHolder key={Date.now()} />
  }

  return (
    <RailItemWrap data-id={data.id}>
      <Link href={href}>
        <RailItemImageWrap theme={{ found: image.found }}>
          {image.url && (
            <RailItemImage
              theme={{
                loaded: imageLoaded,
              }}
              src={image.url}
              alt={data.name}
              onLoad={() => setImageLoaded(true)}
            />
          )}
        </RailItemImageWrap>
        {showTitle && (
          <ProgramNameTitle theme={{ compName }}>{data.name}</ProgramNameTitle>
        )}
      </Link>
    </RailItemWrap>
  )
}
